export default values => ({
  name: values ? values.name : '',
  phone: values ? values.phone : '',
  email: values ? values.email : '',
  role: values ? values.role : ''
});
